<template>
  <div class="details" id="apply">
    <div class="details_wrap" ref="details_wrap">
      <div>
        <i-player
          ref="player"
          v-if="Object.keys(videoData).length"
          :videoinfo="videoData"
          v-on:endValue="end"
          :isCanPlay="isCanPlay"
          @watchPay="watchPay"
        >
        </i-player>
      </div>
      <div class="menus">
        <div v-if="this.$route.query.type == 'live'" class="livetitle">
          <div class="title">
            <div class="name">
              {{ videoData.vTitle ? videoData.vTitle : "" }}
            </div>
            <div class="img_text" v-if="this.$route.query.type == 'video'">
              <img
                src="../../assets/images/sc.png"
                alt
                v-if="videoData.vIsCollect == 1"
                @click="sc(1)"
              />
              <img
                src="../../assets/images/unsc.png"
                v-if="videoData.vIsCollect == 0"
                @click="sc(0)"
                alt
              />
              <span>{{ texts }}</span>
            </div>

            <p>
              <span v-if="videoData.lState == 1"
                >在线人数：{{ realNum }}人</span
              >
            </p>
            <p>
              <span v-if="videoData.vCreateDt && videoData.lState != 1">{{
                getTimes(videoData.vCreateDt)
              }}</span>
            </p>
            <div
              class="people"
              v-if="this.$route.query.type == 'live' && videoData.lState == 0"
            >
              <span>预约人数：{{ videoData.lAppointNum }}人</span>
              <button
                class="footer_yybm"
                @click="signUp(sing)"
                :style="{
                  background:
                    sing == 1
                      ? '#999999'
                      : 'linear-gradient(0deg,rgba(9,131,255,1) 0%,rgba(33,175,255,1) 100%)',
                }"
              >
                {{ text }}
              </button>
            </div>
          </div>
        </div>

        <div class="videotitle" v-if="this.$route.query.type == 'video'">
          <div class="title">
            <div class="name">
              {{ videoData.vTitle ? videoData.vTitle : "" }}
            </div>
            <button
              v-if="this.$route.query.type == 'live' && videoData.lState == 0"
              class="footer_yybm"
              @click="signUp(sing)"
              :style="{
                background:
                  sing == 1
                    ? '#999999'
                    : 'linear-gradient(0deg,rgba(9,131,255,1) 0%,rgba(33,175,255,1) 100%)',
              }"
            >
              {{ text }}
            </button>
          </div>
          <div class="videodesc">
            <p v-if="videoData.vCreateDt">
              {{ getTimes(videoData.vCreateDt) }}
            </p>
            <span class="img_text" v-if="this.$route.query.type == 'video'">
              <img
                src="../../assets/images/sc.png"
                alt
                v-if="videoData.vIsCollect == 1"
                @click="liveCollect(1)"
              />
              <img
                src="../../assets/images/unsc.png"
                v-if="videoData.vIsCollect == 0"
                @click="liveCollect(0)"
                alt
              />
              <span>{{ texts }}</span>
            </span>
          </div>
        </div>
        <ul class="tabmenus">
          <!--三个和两个样式-->
          <!--:style="{width:teacher==1?'50%':'2.46rem'}"-->
          <li
            v-for="(item, index) in list"
            @click="getTab(item, index)"
            :class="{ active: active == index }"
            :key="index"
          >
            <span
              :style="{
                borderRight: teacher == 1 ? 'none' : '',
                width: '100%',
                textAlign: 'center',
              }"
              >{{ item.name }}</span
            >
          </li>
        </ul>
      </div>
    </div>
    <!-- 视频讲师介绍 -->
    <div v-if="activeTab == 'v1'" class="box">
      <i-lecturer :value="videoData.teacher"></i-lecturer>
    </div>
    <div
      class="box"
      v-if="activeTab == 'v2' || activeTab == 'l1' || activeTab == 'c1'"
    >
      <!--课程介绍-->
      <i-course
        v-if="
          videoData.vDesc != undefined &&
          videoData.vDesc != null &&
          videoData.vDesc != ''
        "
        :value="videoData.vDesc"
      ></i-course>
      <!-- <i-lecturer :value="videoData.teacher" v-else></i-lecturer> -->
    </div>
    <div v-if="activeTab == 'v3'" class="container box">
      <i-video
        :video_newest="video_newest"
        v-on:listtomember="fatertpl"
        v-if="video_newest.length > 0"
      ></i-video>
      <img src="../../assets/images/nothing.png" alt v-else class="nothing" />

      <!--相关视频-->
    </div>

    <div v-show="activeTab == 'l2'" class="box" id="ichatbox">
      <i-chat
        style="position: relative; min-height: 100%; flex-grow: 1"
        v-on:onlineuser="onlineuser"
        v-on:onlinecount="onlinecount"
      ></i-chat>
    </div>
    <div v-if="activeTab == 'v4' || activeTab == 'l3'" class="box">
      <div style="width: 100%" v-if="!isCharge">
        <photo v-if="pptlist.length > 0" :imgs="pptlist"></photo>

        <img src="../../assets/images/nothing.png" alt v-else class="nothing" />
      </div>

      <div v-else class="limits">
        <img src="../../assets/images/chahua.png" alt />
        <div class="a">
          <span>您尚未购买课程，购买课程后才能观看</span>
        </div>
      </div>
    </div>

    <div v-if="showimg" class="showimg" @click="cancelshowimg">
      <img :src="imgurl" alt />
    </div>

    <div
      class="buyCC"
      v-if="isCharge && (activeTab == 'l3' || activeTab == 'v4')"
      @click="subscribe()"
    >
      <span>购买课程</span>
      <span>¥{{ curPrice }}</span>
    </div>
  </div>
</template>
<script>
import iLecturer from "../container/lecturer";
import iCourse from "../container/course";

import iChat from "../iChat/iChat";
import iPlayer from "../container/player";

import iVideo from "../container/videoList";
import weui from "weui.js";
import bus from "../bus/index";
import photo from "./photo";

import loginService from "../../plugin/extendFn/loginService";
import AppSetting from '../../AppSetting';
export default {
  data() {
    return {
      isCanPlay: null,
      isVipBuy: 0,
      curPrice: "",
      isshowtime: true,
      nowdt: null,
      pptlist: [],
      realNum: "0",
      active: this.$route.query.type == "live" ? 0 : 0,
      activeTab: "l1",
      videoData: {},
      sing: 0,
      text: "预约报名",
      texts: "收藏",
      anlist: [],
      teacher: this.$route.query.type == "live" ? "1" : "0",
      list: [],
      video_newest: null,
      ra_wxUser: null,
      answer: [],
      socket: "",
      name: "",
      org: "",
      hasNameOrg: "",
      imgurl: "",
      showimg: false,
      ismember: false,
      num: "0",
      position: {
        bottom: 50,
        right: 27,
      },

      fl: "",

      interval: 0,
    };
  },
  props: {},
  components: {
    iLecturer,
    iCourse,
    iChat,
    // iDiscuss,
    iPlayer,
    iVideo,
    photo,
    // iLessonppt
  },
  created() {
    this.$waiting.show(3);
  },
  async mounted() {
    this.ra_wxUser=await loginService.getLoginUser();

    this.$wxFn.wxConfig();
    //存储直播来源参数
    localStorage.setItem("source", this.$route.query.source);
    localStorage.setItem("share", "");

    if (this.$route.query.type == "video") {
      this.list = [
        // { name: "讲师介绍", id: "v1" },
        { name: "课程介绍", id: "v2" },
        { name: "相关课程", id: "v3" },
        // { name: "PPT", id: "v4" },
      ];
      this.getvideodetails();
    } else if (this.$route.query.type == "live") {
      this.list = [
        { name: "课程介绍", id: "l1" },
        { name: "互动讨论", id: "l2" },
        // { name: "PPT", id: "l3" },
      ];

      this.nowdt = new Date().getTime() * 1;

      this.getlivedetails();
    }
    //这里需要校验路由中的渠道参数：判断是否有该参数，并根据不同的参数保存该用户的来源
    //需要的参数1、渠道参数；2、微信用户信息  3、
  },
  computed: {
    isCharge() {
      let status = false;
      if (!this.videoData.buyed) {
        status = true;
      }

      return status;
    },
  },
  methods: {
    // 点击播放按钮 提示去支付
    watchPay() {
      this.subscribe();
    },

    onlinecount(data) {
      this.numCount = data;
    },
    onlineuser(data) {
      this.realNum = data;
    },

    fatertpl(data) {
      if (data == "yes") {
        this.ismember = true;
      } else {
        this.ismember = false;
      }
    },
    cancelMember() {
      this.ismember = false;
    },

    cancelshowimg() {
      this.showimg = false;
    },
    async liveCollect(type) {
      this.ra_wxUser = await loginService.getLoginUser();
      if (await loginService.isNotLogin()) {
        this.login();
      } else if (this.ra_wxUser.uPhone || this.ra_wxUser.uOrg) {
        if (type == 0) {
          this.$postHttp(AppSetting.baseUrl + "/video/collection", {
            uid: this.ra_wxUser.uId,
            vid: this.$route.query.videoId,
          }).then((res) => {
            bus.$emit("isstop", "stop");
            if (res.data.code == 0) {
              this.texts = "已收藏";
              this.videoData.vIsCollect = 1;
              this.toast("收藏成功");
            } else {
              this.topTips("收藏失败");
            }
          });
        } else {
          bus.$emit("isstop", "stop");
          weui.dialog({
            content: "确定要取消收藏吗？",
            className: "yors",
            buttons: [
              {
                label: "取消",
                type: "default",
                onClick: (res) => {},
              },
              {
                label: "确定",
                type: "primary",
                onClick: () => {
                  this.$postHttp(AppSetting.baseUrl + "/video/collection/cancel", {
                    uid: this.ra_wxUser.uId,
                    vid: this.$route.query.videoId,
                  }).then((res) => {
                    if (res.data.code == 0) {
                      this.texts = "收藏";
                      this.videoData.vIsCollect = 0;
                      this.toast("取消收藏成功");
                    } else {
                      this.topTips("取消收藏失败");
                    }
                  });
                },
              },
            ],
          });
        }
      }
    },
    end(val) {
      // this.list[2].name = val;
      // this.ppt = val;
    },
    async signUp(status) {
      this.ra_wxUser=await loginService.getLoginUser();
      if (!this.ra_wxUser) {
        this.login();
      } else {
        if (status == 0) {
          this.$postHttp(AppSetting.baseUrl + "/live/appointment", {
            uid: this.ra_wxUser.uId,
            lid: this.$route.query.liveId,
          }).then((res) => {
            if (res.data.code == 0) {
              this.$set(this.videoData, "lAppointNum", res.data.num);
              this.text = "已预约";
              this.sing = 1;
              this.$toast.success("预约成功");
            } else {
              this.topTips("预约失败");
            }
          });
        } else {
          weui.dialog({
            content: "确定要取消预约吗？",
            className: "yors",
            buttons: [
              {
                label: "取消",
                type: "default",
                onClick: (res) => {
                  // alert('取消')
                },
              },
              {
                label: "确定",
                type: "primary",
                onClick: () => {
                  this.$postHttp(AppSetting.baseUrl + "/live/appointment/cancel", {
                    uid: this.ra_wxUser.uId,
                    lid: this.$route.query.liveId,
                  }).then((res) => {
                    if (res.data.code == 0) {
                      this.$set(this.videoData, "lAppointNum", res.data.num);
                      this.text = "预约报名";
                      this.sing = 0;
                      this.$toast.success("取消成功");
                    } else {
                      this.topTips("取消预约失败");
                    }
                  });
                },
              },
            ],
          });
        }
      }
    },
    getTimes(value) {
      let val = new Date(value).getTime();
      return new Date(val).Format("yyyy.MM.dd hh:mm");
    },
    getTab(item, index) {
      this.activeTab = item.id;
      this.active = index;
      if (index == 1 && this.$route.query.type == "video") {
        this.$postHttp(AppSetting.baseUrl + "/video/list/condition", {
          type: this.videoData.vEgid,
        }).then((res) => {
          if (res.data.code == 0) {
            this.video_newest = res.data.list;
          }
        });
      } else if (
        index == 1 &&
        this.$route.query.type == "live" &&
        this.videoData.lState != 3
      ) {
        setTimeout(() => {
          let box = document.getElementById("box");
          // console.log(box);
          // console.log('元素高度',box.scrollHeight);
          box.scrollTop = box.scrollHeight;
        }, 100);
      }
    },

    getvideodetails() {
      this.$postHttp(AppSetting.baseUrl + "/video/detail", {
        vid: this.$route.query.videoId,
        uid: this.ra_wxUser ? this.ra_wxUser.uId : "0",
      }).then((res) => {
        if (res.data.code == 0) {
          // console.log(res);
          this.hasNameOrg = res.data.hasNameOrg;
          this.videoData = res.data.video;
          this.isCanPlay = res.data.isCanPlay;
          this.videoData.showWatermark = res.data.showWatermark; // 是否展示水印功能
          // this.fl = this.videoData.vFl;

          this.$waiting.hide();
          this.texts = this.videoData.vIsCollect == 1 ? "已收藏" : "收藏";
          let share_title =
            this.videoData.vTitle !== null ? this.videoData.vTitle : "";

          // //微信不支持
          let share_img =
            this.videoData.vShareUrl != null ? this.videoData.vShareUrl : "";

          let desc = this.videoData.vDesc != null ? this.videoData.vDesc : "";
          let sharedesc =
            "" +
            this.videoData.teacher.tName +
            "" +
            this.videoData.teacher.tOrg; //分享描述
          this.curPrice = this.videoData.vFees;
          let re = new RegExp("<[^<>]+>", "g");
          let text = desc.replace(re, "");
          //或
          let share_desc = desc.replace(/<[^<>]+>/g, "");
          setTimeout(() => {
            document.title = this.videoData.vTitle;
          }, 100);

          // let share_url = '';
          let hostname = location.hostname;

          let share_url = window.location.href;
          let firends =
            this.videoData.teacher.tOrg +
            this.videoData.teacher.tName +
            "：" +
            this.videoData.vTitle;
          // console.log('分享----》',share_title, sharedesc, share_img, share_url,this.$route.query.videoId)
          this.$wxFn.share(
            share_title,
            sharedesc,
            share_img,
            share_url,
            this.$route.query.videoId,
            firends,
            "video"
          );
          // this.videoData.vIsShare = 1;

          //判断课程介绍是否有数据没有的话显示讲师介绍内容 有数据就不显示讲师内容

          if (this.videoData.vIsShare == 0) {
            //未分享
            let setval = setInterval(() => {
              // console.log(localStorage.getItem('share'))
              // console.log(this.$route.videoId)
              if (localStorage.getItem("share") == this.$route.query.videoId) {
                clearInterval(setval);
              }
            }, 500);
          }
        }
      });
      this.$postHttp(AppSetting.baseUrl + "/video/ppt", {
        vid: this.$route.query.videoId,
        uid: this.ra_wxUser ? this.ra_wxUser.uId : "0",
      }).then((res) => {
        if (res.data.code == 0) {
          this.pptlist = res.data.list;
        }
      });
    },

    setInterval(dt, state) {
      let interval = 1000 * 30; // 60秒
      let now = new Date().getTime();
      let c = now - dt;
      if (Math.abs(c < 2 * 60 * 1000)) {
        // 绝对值小于2分钟时，设置每10秒钟跑一次
        interval = 1000 * 10;
      } else if (c < 5 * 60 * 1000 && c > 0) {
        // 小于5分钟时，设置每60秒钟跑一次
        interval = 1000 * 60;
      } else if (c > 5 * 60 * 1000) {
        // 大于5分钟时，设置每5分钟跑一次
        interval = 1000 * 60 * 5;
      }

      const tm = () => {
        this.getlivedetails();
      };
      this.interval = setTimeout(tm, interval);
    },

    playLive() {
      clearTimeout(this.interval);
      setTimeout(() => {
        this.$refs["player"].playVideo();
      }, 1500);
    },

    getlivedetails() {
      // let res = await this.$postHttp(AppSetting.baseUrl + '/live/online/update',{lid:this.$route.query.liveId,type:1})
      // console.log(res);
      this.$postHttp(AppSetting.baseUrl + "/live/detail", {
        lid: this.$route.query.liveId,
        uid: this.ra_wxUser ? this.ra_wxUser.uId : "0",
      }).then((res) => {
        if (res.data.code == 0) {
          // TODO: 获取直播地址
          this.videoData = res.data.live;
          this.isCanPlay = res.data.isCanPlay;
          this.videoData.showWatermark = res.data.showWatermark; // 是否展示水印功能
          this.$waiting.hide();
          this.videoData.vDesc = this.videoData.lDesc;
          // console.log('1111',this.videoData.vDesc);

          this.videoData.vCreateDt = this.videoData.lDt;
          this.videoData.vTitle = this.videoData.lTitle;
          this.videoData.vViewUrl = this.videoData.lViewUrl;
          this.sing = this.videoData.lIsAppoint == 1 ? 1 : 0;
          this.text = this.videoData.lIsAppoint == 1 ? "已预约" : "预约报名";
          this.curPrice = this.videoData.lFees;

          //是否会员观看标志
          this.isVipBuy = res.data.isfree;
          if (this.videoData.lIsCharge == 0) {
            //免费
            this.curPrice = "0";
            this.videoData.lFees = "0";
          } else if (this.isVipBuy == "1") {
            //会员免费
            this.curPrice = "0";
            this.videoData.lFees = "0";
          }

          if (res.data.live.lState > 1) {
            //   this.list[2].name = 'PPT';
            this.list = [
              // {name:"讲师介绍"},
              { name: "课程介绍", id: "l1" },
              // {name:'互动讨论',id:'l2'},
              // { name: "PPT", id: "l3" },
            ];
          } else {
            let socket;
            socket = io.connect(this.GLOBAL.SOCKETPORT); //生产端口
          }

          // 直接中
          if (res.data.live.lState == 1) {
            this.playLive();
          } else if (res.data.live.lState == 0) {
            this.setInterval(this.videoData.lDt, res.data.live.lState);
          }

          let firends = "";
          let sharedesc = "";
          if (this.videoData.teache) {
            firends =
              "【直播】" +
              this.videoData.teacher.tOrg +
              this.videoData.teacher.tName +
              "：" +
              this.videoData.lTitle;
            sharedesc = "" + this.videoData.teacher.tName + "" + 述;
            this.videoData.teacher.tOrg; //分享描
          }
          let share_title =
            this.videoData.vTitle !== null
              ? "直播：" + this.videoData.vTitle
              : "直播：";
          let share_img =
            this.videoData.lShareUrl != null ? this.videoData.lShareUrl : "";

          setTimeout(() => {
            document.title = this.videoData.vTitle;
          }, 100);
          let share_url = window.location.href;
          this.$wxFn.share(
            share_title,
            sharedesc,
            share_img,
            share_url,
            this.$route.query.liveId,
            firends,
            "live"
          );
        }
      });
      this.$postHttp(AppSetting.baseUrl + "/live/ppt", {
        lid: this.$route.query.liveId,
        uid: this.ra_wxUser ? this.ra_wxUser.uId : "0",
      }).then((res) => {
        if (res.data.code == 0) {
          this.pptlist = res.data.list || [];
        }
      });
    },
    onBridgeReady(params) {
      var that = this;
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: params.appId, //公众号名称，由商户传入
          timeStamp: params.timeStamp + "", //支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
          nonceStr: params.nonceStr, //支付签名随机串，不长于 32 位
          package: params.package, //统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
          signType: "MD5", //签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          paySign: params.sign, //支付签名
        },
        function (res) {
          if (res.err_msg === "get_brand_wcpay_request:ok") {
            that.buyed = true;
            that.videoData.buyed = true;
            //that.$toast.success('购买成功[测试3]')
            that.playLive();
            //console.log("赶紧给我刷新啊")
            //that.$router.push({ path: "/myOrder" });
          } else if (res.err_msg === "get_brand_wcpay_request:fail") {
            // this.alert("支付失败！");
          }
        }
      );
    },
    login(){
      loginService.login(this.$router)
         .then(loginUser=>{
            this.ra_wxUser = loginUser;
         })
    },
    subscribe() {
      if (!this.ra_wxUser) {
        this.login();
        return;
      }

      let param = {
        orderType: 2, //vip购买，1 视频购买，2直播购买，3会议购买
        bId: this.$route.query.liveId,
        payPrice: this.curPrice,
        uid: this.ra_wxUser.uId,
        isVipBuy: this.isVipBuy,
      };
      this.$postHttp(AppSetting.baseUrl + "/order/app/add", param).then((res) => {
        if (res.data.code == 0) {
          if (this.curPrice <= 0) {
            this.buyed = true;
            this.videoData.buyed = true;
            //this.$toast.success('购买成功[测试1]')
            this.playLive();
            return;
          }
          const pay_params = JSON.parse(res.data.parMap);
          if (typeof WeixinJSBridge === "undefined") {
            if (document.addEventListener) {
              document.addEventListener(
                "WeixinJSBridgeReady",
                this.onBridgeReady,
                false
              );
            } else if (document.attachEvent) {
              document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
              document.attachEvent("onWeixinJSBridgeReady", this.onBridgeReady);
            }
          } else {
            this.onBridgeReady(pay_params);
          }
        } else if (res.data.code == 2) {
          this.toast("购买成功");
          //this.$toast.success('购买成功[测试2]')
          this.playLive();
        } else {
          this.confirm(
            "授权失败，点击确定微信授权",
            "取消",
            "确定",
            () => {
              return true;
            },
            () => {
              this.login();
              return true;
            }
          );
        }
      });
    },
  },
  beforeDestroy() {
    clearTimeout(this.interval);
  },
};
</script>
<style scoped lang="scss">
.ichatbox {
  background: #ffffff;
  padding-top: 0.2rem;
  flex-grow: 1;
  overflow: hidden;

  img {
    display: inline-block;
    width: 1rem;
    height: 1rem;
  }
}

.details {
  display: flex;
  width: 100vw;

  flex-direction: column;

  .details_wrap {
    /*height: 6.42rem;*/
    width: 100vw;

    flex-grow: 0;
    z-index: 1;
  }
}

div {
  background: #ffffff;
}

.box {
  background: #ffffff;
  width: 100vw;
  height: 8rem;
  overflow-y: scroll;
  overflow-x: hidden;
  position: relative;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
  display: flex;
}

.container {
  padding: 0.2rem 0.3rem;
  box-sizing: border-box;
  flex-grow: 1;
  width: 100vw;
  height: 100%;
  position: relative;
  z-index: 0;
  overflow-y: scroll;
  /*会导致z-index失效*/

  -webkit-overflow-scrolling: touch;
}

.livetitle {
  width: 7.5rem;
  padding: 0.15rem 0.25rem 0.2rem 0.29rem;
  box-sizing: border-box;
  /*line-height: 0.4rem;*/
  p {
    font-size: 0.28rem;
    color: #666666;
  }

  .title {
    width: 100%;
  }

  .name {
    /*width: 5rem;*/
    color: #333333;
    font-size: 0.34rem;
    font-weight: bold;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; //2行
    -webkit-box-orient: vertical;
    /*white-space: nowrap;*/
    text-overflow: ellipsis;
  }
}

.videotitle {
  width: 7.5rem;
  /*height: 1.34rem;*/
  font-size: 0.28rem;
  line-height: 0.5rem;
  padding: 0.15rem 0.25rem 0.2rem 0.29rem;
  box-sizing: border-box;

  .videodesc {
    display: flex;
    align-items: center;
    justify-content: space-between;

    p {
      color: #666666;
    }

    img {
      width: 0.38rem;
      height: 0.38rem;
      margin-right: 0.09rem;
    }
  }

  .img_text {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 1.8rem;

    img {
      width: 0.38rem;
      height: 0.38rem;
      margin-right: 0.09rem;
    }

    font-size: 0.28rem;
    color: #666666;
  }

  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    .name {
      /*width: 5rem;*/
      color: #333333;
      font-size: 0.34rem;
      font-weight: bold;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2; //2行
      -webkit-box-orient: vertical;
      /*white-space: nowrap;*/
      /*text-overflow: ellipsis;*/
    }

    .img_text {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      width: 1.8rem;

      color: #666666;
    }
  }
}

.menus {
  background: #ffffff;
  z-index: 100;
}

.tabmenus {
  display: flex;
  width: 7.5rem;
  height: 0.8rem;
  background: #ffffff;
  border-top: 1px solid #e6e6e6;
  border-bottom: 1px solid #e6e6e6;
  font-size: 0.28rem;
  color: #666666;
  align-items: center;
  z-index: 1;
  display: flex;

  li {
    flex-grow: 1;
    // width: 2.46rem;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  li:nth-of-type(2) > span {
    display: inline-block;
    width: 2.46rem;
    line-height: 0.3rem;
    text-align: center;
    border-left: 1px solid #e6e6e6;
    /*border-right: 1px solid #E6E6E6;*/
  }

  .active {
    color: #ff781b;
    border-bottom: 1px solid #ff781b;
  }

  li:nth-of-type(3) > span {
    display: inline-block;
    width: 2.46rem;
    line-height: 0.3rem;
    text-align: center;
    border-left: 1px solid #e6e6e6;
    /*border-right: 1px solid #E6E6E6;*/
  }
}

.footer_yybm {
  width: 1.4rem;
  height: 0.5rem;
  flex-shrink: 0;
  background: linear-gradient(
    0deg,
    rgba(9, 131, 255, 1) 0%,
    rgba(33, 175, 255, 1) 100%
  );
  border-radius: 25px;
  font-size: 0.26rem;
  color: #ffffff;
  border: none;
  outline: none;
}

video {
  width: 7.5rem;
  height: 4.22rem;
}

.showimg {
  position: absolute;
  bottom: 0;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.5);

  img {
    width: 100%;
    margin-top: 2rem;
    z-index: 9999;
  }
}

.people {
  display: flex;
  justify-content: space-between;
  align-items: center;

  span:nth-of-type(1) {
    font-size: 0.26rem;
  }
}

.member {
  background: rgba(0, 0, 0, 0.5);
  min-width: 100vw;
  min-height: 100vh;
  position: fixed !important;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 9999 !important;

  > div {
    width: 5rem;
    z-index: 10001 !important;
    background: #ffffff;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    font-size: 0.16rem;
    margin: 4rem auto;
    height: 3.5rem;
    padding: 0.2rem 0.28rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    ul {
      width: 100%;

      li:nth-of-type(1) {
        font-weight: bolder;
        font-size: 0.32rem;
      }

      li:nth-of-type(2) {
        text-indent: 0.56rem;
        font-size: 0.28rem;
        margin-top: 0.2rem;
      }

      li {
        width: 100%;
        font-size: 0.28rem;
      }
    }

    > p {
      width: 100%;
      display: flex;
      justify-content: space-between;

      button {
        width: 2rem;
        height: 0.6rem;
        border: none;
        outline: none;
        background: linear-gradient(#e7e8e9, #babbbb);
        color: #333;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
      }

      a > button {
        color: #ffffff;
        background: linear-gradient(#21afff, #007fff);
      }
    }
  }
}

.nothing {
  width: 3rem;
  height: auto;
  margin: 0 auto;
  display: block;
  margin-top: 1.5rem;
  /*height: 100%;*/
}

.limits {
  img {
    width: 2.64rem;
    height: auto;
  }

  margin: 0 auto;
  margin-top: 0.5rem;
  font-size: 0.28rem;
  color: #666666;
  text-align: center;
  line-height: 0.44rem;

  .goMen {
    color: #5bb8f8;
  }
}

.buyCC {
  width: 100%;
  background: #05a2ff;
  position: fixed;
  bottom: 0px;
  font-size: 0.3rem;
  color: #fff;
  text-align: center;
  line-height: 0.9rem;
  height: 0.9rem;
}
</style>



// WEBPACK FOOTER //
// src/components/container/details.vue